<!-- 构件卡片两种形态 -->
<template>
  <div id="ListItem">
<!--  卡片样式  -->
    <div v-if="type === 'card'" key="card" class="card" :class="{'is-checked':itemData.isChecked, 'card-web': platform === 'web', 'card-en': showThreeLine}">
      <el-checkbox
          v-if="['g', 'r'].includes(platform)"
          v-model="itemData.isChecked"
          class="card-checkbox"
          :class="itemData.isChecked ? 'block': 'none'"
          @change="checkChange"
      />
      <ul class="badge-list">
        <li v-if="itemData.parametricSize || itemData.isParametric" class="badge badge-parametric">
          <img :src="isEn ? require(`@/assets/image/icon_canshu_en.png`):require(`@/assets/image/icon_canshu_zh.png`)" width="16" />
        </li>
        <li v-if="itemData.hasPlaceholder" class="badge badge-placeholder">
          <img :src="isEn ? require(`@/assets/image/icon_tuli_en.png`):require(`@/assets/image/icon_tuli_zh.png`)" width="16" />
        </li>
      </ul>
      <div class="top-img">
        <div class="img">
          <el-image :src="$staticHost(itemData.thumbnail)" fit="contain">
            <div slot="error" class="image-slot">
              <img :src="DefaultCompImg" alt="" />
            </div>
          </el-image>
        </div>
        <div class="img-btn">
          <template v-if="platform === 'g'">
            <el-button v-if="!hidePlaceBtn" type="primary" @click.stop="toPlace(itemData)">{{ $t('place.place') }}</el-button>
            <el-button v-if="!hideLoadBtn" @click.stop="toLoad(itemData)">{{ $t('load.load') }}</el-button>
          </template>
          <template v-if="platform === 'web'">
            <el-button type="primary" icon="gjw-iconfont gjw-icon-wenjian-xiazai" :title="$t('load.download')" @click.stop="toDownload(itemData)"></el-button>
            <el-button v-if="!itemData.isFavourite" icon="gjw-iconfont gjw-icon-icon_collect0" :title="$t('component.favorite')" @click.stop="toFavorite(itemData, true)"></el-button>
            <el-button v-else class="favorite-icon" icon="gjw-iconfont gjw-icon-icon_collect1" :title="$t('component.cancelFavorite')" @click.stop="toFavorite(itemData, false)"></el-button>
          </template>
        </div>
      </div>
      <div class="bottom-text" :class="{'long-text': showThreeLine}">
        <el-tooltip :content="itemData.name" placement="left">
          <div :class="showThreeLine ? 'three-line-text' : 'single-line-text'">{{ itemData.name }}</div>
        </el-tooltip>
      </div>
      <div v-if="itemData.isLoaded" class="card-isloaded-tag">
        <i class="el-icon-check"></i>
      </div>
    </div>
<!--  行列表样式  -->
    <div v-else class="row-card" key="row" :class="{'is-checked':itemData.isChecked}">
      <div class="row-left">
        <el-checkbox v-if="platform !== 'cs'" v-model="itemData.isChecked" @change="checkChange" />
        <div class="row-imgs">
          <el-image class="row-img" :src="$staticHost(itemData.thumbnail)" fit="contain">
            <div slot="error" class="image-slot">
              <img :src="DefaultCompImg" width="40" alt="" />
            </div>
          </el-image>
          <!-- 平面图例 -->
          <el-image
            v-if="itemData.planPlaceholderThumbnail"
            class="row-img"
            :src="$staticHost(itemData.planPlaceholderThumbnail)"
            fit="contain"
          >
            <div slot="error" class="image-slot">
              <img :src="DefaultCompImg" width="40" alt="" />
            </div>
          </el-image>
        </div>
        <div class="row-name">
          <el-tooltip :content="itemData.name" placement="top">
            <span>{{ itemData.name }}</span>
          </el-tooltip>
          <div v-if="hasBadges || itemData.isLoaded" class="row-meta">
            <ul v-if="hasBadges" class="badge-list">
              <li v-if="itemData.parametricSize || itemData.isParametric" class="badge badge-parametric">
                <img :src="isEn ? require(`@/assets/image/icon_canshu_en.png`):require(`@/assets/image/icon_canshu_zh.png`)" width="16" />
              </li>
              <li v-if="itemData.hasPlaceholder" class="badge badge-placeholder">
                <img :src="isEn ? require(`@/assets/image/icon_tuli_en.png`):require(`@/assets/image/icon_tuli_zh.png`)" width="16" />
              </li>
            </ul>
            <span v-if="hasBadges && itemData.isLoaded" class="meta-divider"></span>
            <span v-if="itemData.isLoaded" class="isloaded-tag">{{ isStandalone ? $t('load.loaded') : $t('component.added') }}</span>
          </div>
        </div>
      </div>
      <div class="row-right">
        <el-button v-if="!hidePlaceBtn" type="text" @click.stop="toPlace(itemData)">{{ $t('place.place') }}</el-button>
        <el-button v-if="!hideLoadBtn" type="text" @click.stop="toLoad(itemData)">{{ $t('load.load') }}</el-button>
      </div>
    </div>
    <!-- 载入重名弹框 -->
    <check-rename-dialog ref="CheckRenameDialogRef" :dialogVisible="checkRenameDialogVisible" :selectedList="selectedList" @confirm="handleConfirmConfirm" @close="checkRenameDialogVisible = false; subdivideType = ''"/>
    <!-- 载入 -->
    <load-progress-bar-dialog ref="LoadProgressBarDialogRef" :selectedList="selectedList" @clearSelection="()=>{}"/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DefaultCompImg from '@/assets/image/default_comp_img.png'
import { GetProjectInfo, LoadPublicComponent, PlacePublicComponent, CheckPublicComponentLoaded, RecordJournal, buildPublicComponentPayload } from '@/core/gcsUtils'
import { localCachePath, checkExistFile } from '@/core/desktopCache'
import checkLoginMixin from '@/mixins/checkLoginMixin'
import CheckRenameDialog from './CheckRenameComponentDialog.vue'
import LoadProgressBarDialog from './LoadProgressBarDialog.vue'
export default {
  name: 'ListItem',
  mixins: [checkLoginMixin],
  components: {
    CheckRenameDialog,
    LoadProgressBarDialog
  },
  props: {
    type: {
      type: String,
      default: 'card'
    },
    // 从专题列表进入时，
    trackParams: {
      type: Object,
      default() {
        return {}
      }
    },
    // 数据内容
    compItem: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      DefaultCompImg,
      saveAsPath: '',
      familyFoundStrategy: 'FFS_CREATE',
      checkRenameDialogVisible: false,
      itemData: this.compItem || {}
    }
  },
  watch: {
    compItem(newVal) {
      this.itemData = newVal || {}
    }
  },
  computed: {
    ...mapGetters({
      isStandalone: 'isStandalone',
      platform: 'platform',
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      detail: 'componentDetail/DETAIL',
      currentType: 'componentDetail/CURRENTTYPE',
      language: 'language',
    }),
    // 是否是英文环境
    isEn() {
      return this.language && this.language.startsWith('en_')
    },
    showThreeLine() {
      return this.platform !== 'web'
    },
    hidePlaceBtn() {
      // 道路软件不显示布置按钮
      return this.softwareCode === 'AppGroad' || this.softwareCode === 'AppGbr'
    },
    hideLoadBtn() {
      // CyberStation软件不显示载入按钮
      return this.platform === 'cs'
    },
    selectedList() {
      return [this.itemData]
    },
    // 行列表是否有标签（参数化/图例）
    hasBadges() {
      return !!(this.itemData.parametricSize || this.itemData.isParametric || this.itemData.hasPlaceholder)
    },
  },
  methods: {
    ...mapMutations({
      setComponentInfo: 'componentDownload/setComponentInfo',
      setShowDialog: 'componentDownload/setShowDialog',
    }),
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
      loadRevitUrl: 'componentDownload/loadRevitUrl',
      loadTimes: 'componentDownload/loadTimes',
    }),
    // 载入
    async toLoad() {
      if (['AppGbr'].includes(this.softwareCode)) {
        this.toNewLoad(this.itemData).catch()
        return
      }
      const comp = this.itemData
      const params = buildPublicComponentPayload(comp)
      try {
        RecordJournal('LoadPublicComponentFromComponents', params)
        const login = await this.checkLogin()
        if (login) {
          this.$fullLoading.open(this.$t('load.loading'))
          await LoadPublicComponent(params)
          const { data: projectInfo } = await GetProjectInfo()
          this.$tracks({
            event: 'shopComponentLoad',
            params: {
              g_c_component_id: comp.publicComponentId,
              g_c_source: 'shop_gjw',
              g_c_project_id: projectInfo && projectInfo.id,
              g_c_project_file_path: projectInfo && projectInfo.path,
              g_c_project_file_name: projectInfo && projectInfo.name,
              g_c_batch: false,
              g_c_sorting: comp.sortIndex || null,
              ...this.trackParams,
            }
          })
        }
      } catch (error) {
        this.$message.error('载入失败')
      } finally {
        // 检查是否已添加
        await this.checkLoaded(params)
        this.$fullLoading.close()
      }
    },
    handleConfirmConfirm(data, row, actionType, subdivideType, batchSelectData) {
      switch (actionType) {
        case 'place':
          data.forEach((item) => {
            this.$refs.pluginPlaceTypeDialog?.openDialog(row, true, item.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE')
          })
          break
        case 'load':
          if (subdivideType === 'single') {
            data.forEach((item) => {
              this.$refs.LoadProgressBarDialogRef?.openDialog(row, subdivideType, item.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE')
            })
          }
          break
      }
    },
    async toNewLoad(row, subdivideType = 'single', batchSelectData) {
      if (subdivideType === 'single') {
        // await this.$api.resource.getSpaceResourceDetail(this.spaceId, row.spaceResourceId)
      }
      const componentNames = [row.name]
      const result = await this.$desktopClient.ListComponentsByNames(componentNames)
      if (result.code === 'success') {
        const updatedDataList = result.data
        if (updatedDataList.length) {
          this.checkRenameDialogVisible = true
          this.$refs.CheckRenameDialogRef?.init(updatedDataList, row, 'load', subdivideType, batchSelectData)
        } else if (subdivideType === 'single') {
          await this.$refs.LoadProgressBarDialogRef?.openDialog(row, subdivideType)
        }
      }
    },
    async replayLoadPublicComponent(args) {
      const { code } = await LoadPublicComponent(args)
      return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:LoadPublicComponent Failed', data: false }
    },
    // 获取点击布置时的构件规格
    async getGcsFamilyTypeName(componentId) {
      try {
        // 需要先从详情页获取规格，如果没有打开详情页，再调接口获取
        if (this.detail && this.detail.id === this.itemData.id && this.currentType && this.currentType.name) {
          return this.currentType.name
        }
        let familyTypes
        if (['bimmake'].includes(this.softwareCode)) {
          const detail = await this.$api.generalComponent.detail(componentId, this.softwareVersion)
          familyTypes = detail.familyTypes
        } else {
          const detail = await this.$api.gcsComponent.detail(this.softwareCode, componentId, this.softwareVersion)
          familyTypes = detail.familyTypes
        }
        if (familyTypes && familyTypes.length) {
          return familyTypes[0].name
        }
        return null
      } catch (error) {
        return null
      }
    },
    beforeDownload(name, suffix) {
      const catchPath = localCachePath()
      this.saveAsPath = `${catchPath}\\${this.itemData.id}\\${name}.${suffix}`
      return checkExistFile(this.saveAsPath)
    },
    // 布置
    async toPlace() {
      const comp = this.itemData
      const params = buildPublicComponentPayload(comp)
      try {
        const login = await this.checkLogin()
        if (login) {
          this.$fullLoading.open(this.$t('load.downloading'))
          const familyType = await this.getGcsFamilyTypeName(comp.publicComponentId)
          RecordJournal('PlacePublicComponentFromComponents', { publicComponent: params, familyTypeToBePlaced: familyType })
          const { data } = await GetProjectInfo()
          PlacePublicComponent(params, familyType)
          this.$tracks({
            event: 'shopComponentPlace',
            params: {
              g_c_component_id: comp.publicComponentId,
              g_c_component_name: comp.name,
              g_c_source: 'shop_gjw',
              g_c_project_id: data && data.id,
              g_c_project_file_path: data && data.path,
              g_c_project_file_name: data && data.name,
              g_c_sorting: comp.sortIndex || null,
              ...this.trackParams,
            }
          })
        }
      } catch (error) {
        this.$message.error('布置失败')
      } finally {
        // 检查是否已添加
        await this.checkLoaded(params)
        this.$fullLoading.close()
      }
    },
    async replayPlacePublicComponent(args) {
      const { publicComponent: params, familyTypeToBePlaced: familyType } = args
      const { code } = await PlacePublicComponent(params, familyType)
      return code === 'success' ? { code: 'success', data: true } : { code: 'failure', message: 'actionName:PlacePublicComponent Failed', data: false }
    },
    // 检查是否已添加
    async checkLoaded(params) {
      if (this.platform === 'cs') {
        this.itemData.isLoaded = false
        return
      }
      const { data } = await CheckPublicComponentLoaded([params])
      const componentsLoadedArr = data || []
      const loadedObj = componentsLoadedArr.find((it) => String(it.publicComponentId) === String(params.id)) || {}
      this.itemData.isLoaded = loadedObj.isLoaded
    },
    checkChange() {
      this.$emit('check-change', { item: this.itemData })
    },
    // web端下载
    async toDownload(comp) {
      await this.loadUserInfo()
      if (this.user.id) {
        try {
          this.$fullLoading.open('正在获取版本')
          // 获取构件版本
          comp.softwareVersions = await this.$api.components.versions(comp.platformCode, comp.softwareCode, comp.publicComponentId)
          if (comp.platformCode === 'REVIT') {
            this.loadRevitUrl().catch()
            await this.loadTimes()
          }
          this.setComponentInfo(comp)
          this.setShowDialog(true)
        } finally {
          this.$fullLoading.close()
        }
      } else {
        this.$showLogin()
      }
    },
    async toFavorite(comp, isSetFavorite) {
      await this.loadUserInfo()
      if (this.user.id) {
        const text = isSetFavorite ? '正在收藏构件' : '正在取消收藏构件'
        this.$fullLoading.open(text)
        try {
          const apiName = isSetFavorite ? 'favorite' : 'favoriteCancel'
          await this.$api.components[apiName](comp.publicComponentId, { sourceId: comp.publicComponentId })
          const successTip = isSetFavorite ? '已收藏，可在构件坞官网右上角“我的收藏”找到' : '取消收藏成功'
          this.$message.success(successTip)
          this.itemData = { ...this.itemData, isFavourite: isSetFavorite }
          // 打点--单个取消收藏
          if (isSetFavorite) {
            this.$tracks({
              event: 'shopComponentFavorite',
              params: {
                g_c_component_id: comp.publicComponentId,
                g_c_sorting: comp.sortIndex || null,
                ...this.trackParams
              }
            })
          } else {
            this.$tracks({
              event: 'unfavourite',
              params: {
                batch: false,
                source: 'Scenes',
                g_c_sorting: comp.sortIndex || null,
                ...this.trackParams,
              }
            })
          }
        } catch (e) {
          const failTip = isSetFavorite ? '收藏失败' : '取消收藏失败'
          this.$message.error(failTip)
        } finally {
          this.$fullLoading.close()
        }
      } else {
        this.$showLogin()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.active-item{
  .card{
    border: 1px solid @theme-color;
    box-shadow: 0 4px 4px rgba(82, 145, 221, 0.2);
    border-radius: 2px;
  }
  .row-card{
    background: @theme-select-bg;
  }
}
.card{
  width: 136px;
  height: 136px;
  background: @white;
  position: relative;
  &.card-web{
    height: 172px;
    .top-img{
      .img{
        width: 128px;
        height: 128px;
      }
    }
  }
  &.card-en{
    height: 200px;
    .top-img{
      .img{
        width: 128px;
        height: 128px;
      }
    }
  }
  &.is-checked{
    border: 1px solid @theme-color;
    box-shadow: 0 4px 4px rgba(82, 145, 221, 0.2);
    border-radius: 2px;
  }
  &:hover{
    border: 1px solid @theme-color;
    box-shadow: 0 4px 4px rgba(82, 145, 221, 0.2);
    border-radius: 2px;
    .img-btn{
      display: block;
    }
    .card-checkbox{
      display: block!important;
    }
  }
  .card-checkbox{
    position: absolute;
    top: 4px;
    left: 4px;
    &.block{
      display: block;
    }
    &.none{
      display: none;
    }
  }
  .badge-list{
    position: absolute;
    top: 4px;
    right: 0;
    z-index: 99;
  }
  .top-img{
    position: relative;
    padding: 8px 0;
    .img{
      margin: 0 auto;
      width: 96px;
      height: 96px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .img-btn{
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 8px;
    left: 0;
    display: none;
  }
  .favorite-icon{
    color: orange;
  }
  .card-isloaded-tag{
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 18px;
    height: 18px;
    color: @white;
    font-size: 12px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    background: #52C41A;
    border-radius: 100% 0 0 0;
    padding-bottom: 1px;
    padding-right: 1px;
  }
  .bottom-text{
    padding: 0 4px;
    text-align: center;
    line-height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    &.long-text{
      height: 56px;
    }
    .single-line-text{
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .three-line-text{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
.row-card{
  height: 56px;
  padding: 0 10px;
  background: @white;
  border-top: 1px solid @theme-border-color;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &:hover{
    background: @theme-select-bg;
  }
  &.is-checked{
    background: @theme-select-bg;
  }
  .row-left{
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .row-imgs{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    margin: 0 10px;
  }
  .row-img{
    width: 40px;
    height: 40px;
    border: 1px solid @theme-border-color;
  }
  .row-name{
    flex: 1;
    width: 1px;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
  }
  .row-meta{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 4px;
    gap: 8px;
    .badge-list{
      margin-top: 0;
      gap: 4px;
      .badge{
        margin-right: 0;
      }
    }
  }
  .meta-divider{
    width: 1px;
    height: 16px;
    flex-shrink: 0;
    background: #D2D9E3;
  }
  .isloaded-tag{
    font-size: 10px;
    line-height: 16px;
    color: #52C41A;
    border: 1px solid #52C41A;
    border-radius: 2px;
    padding: 0 4px;
    box-sizing: border-box;
  }
  .row-right{
    flex: 0 0 80px;
    text-align: center;
  }
}
.badge-list{
  display: flex;
  flex-direction: row;
  align-items: center;
  .badge {
    margin-right: 6px;
    font-size: 16px;
    &.badge-parametric {
      color: #1a90ff;
    }
    &.badge-placeholder{
      color: #f29d38;
    }
  }
}
</style>
